import { type ValidatorResult } from 'ember-changeset-validations';
import { validatePresence } from 'ember-changeset-validations/validators';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { customMessageValidator } from 'uplisting-frontend/validators/custom-message';

const MESSAGE_REQUIRED_REASONS = [
  'DECLINE_REASON_HOST_DOUBLE',
  'DECLINE_REASON_HOST_OTHER',
];

export const AirbnbOfficialBookingValidation = {
  reason: validatePresence(true),
  subReason: customMessageValidator(
    'airbnb_official_booking_sub_reason_present',
    function (
      key: string,
      newValue: unknown,
      oldValue: unknown,
      changes: Record<string, unknown>,
      content: Record<string, unknown>,
    ): ValidatorResult {
      const { cancellationReasons } =
        content as unknown as ModelRegistry['airbnb-official-booking'];

      const reason = cancellationReasons.find(
        (r) => r.reason === changes['reason'],
      );

      if (!reason || !reason.sub_reasons.length) {
        return true;
      }

      return validatePresence({ presence: true, ignoreBlank: true })(
        key,
        newValue,
        oldValue,
        changes,
        content,
      );
    },
  ),
  messageToGuest: customMessageValidator(
    'airbnb_official_booking_guest_message_present',
    function (
      key: string,
      newValue: unknown,
      oldValue: unknown,
      changes: Record<string, unknown>,
      content: Record<string, unknown>,
    ): ValidatorResult {
      const isMessageRequired = MESSAGE_REQUIRED_REASONS.includes(
        changes['reason'] as string,
      );

      if (!isMessageRequired) {
        return true;
      }

      return validatePresence({ presence: true, ignoreBlank: true })(
        key,
        newValue,
        oldValue,
        changes,
        content,
      );
    },
  ),
};
